export default {
  title: "Regra tipo 6 - Prioridade dos projetos",
  subtitle: "Qual a prioridade do projeto no rateio dos salários dos colaboradores? (N representa a última prioridade)",
  token: "project_order",
  orderBy: "value_c",
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "Prioridade",
          key: "value_c",
          type: "priority",
        },
        {
          label: "Área",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome do CC",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Regra tipo 6 - Prioridade dos projetos",
    form: [
      {
        label: "Informe o Centro de Custo:",
        type: "list",
        info: "Acrescente * para selecionar todos",
        key: "value_b",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe a prioridade:",
        type: "priority",
        key: "value_c",
        placeholder: "",
        info: "N para definir última prioridade",
        value: "*",
        visible: false,
      },
    ],
  },
};
